import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, Form, FormGroup, Message, RadioGroup, Radio } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import CKEditorFrom from '../../components/forms/input/CKEditorFrom'
import {
  getProgressOperationalprogress,
  updateProgressOperationalprogress,
  saveProgressFeedback,
  updateProgressFeedback,
  deleteProgressFeedback,
} from '../../redux/actions/projectProgress'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import CommentForm from './CommentForm'
import CommentView from './CommentView'
import ButtonPanel from '../ButtonPanel'
import { getValueFromOptions } from '../../utils/dataUtil'
import WarningMessage from '../../components/message/WarningMessage/WarningMessage'

export default function OperationalProgressWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [progressId, setProgressId] = useState()

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    // let progressId = location.search.substring(1)
    let progressId = sessionStorage.getItem('param')?.substring(1)
    console.log('OperationalProgressWidget', _schema, 'progressId', progressId)
    setProgressId(progressId)
    setFormSchema(_schema)
  }, [_schema])

  const handleCallService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      console.log('call update.')
      const response = await updateProgressOperationalprogress(
        projectId,
        projectProgressId,
        request
      )

      console.log('response', response)

      if (response) {
        onChangeIsEdit(false)
        setFormSchema(response)
        await dispatch(getSchemaSidebar(projectId))
      } else {
        setIsError(true)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallCommentService = async (request, projectProgressId) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      if (request.value.value || request.value.id) {
        if (request.value.value) {
          let response

          if (request.value.id) {
            console.log('call update.')
            response = await updateProgressFeedback(projectId, projectProgressId, request)
          } else {
            console.log('call save.')
            response = await saveProgressFeedback(projectId, projectProgressId, request)
          }

          console.log('response', response)
          if (response) {
            onChangeIsEdit(false)
            let _schema = formSchema
            _schema.comment = response
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        } else {
          let deleteResult = await deleteProgressFeedback(
            projectId,
            projectProgressId,
            request.value.id
          )

          if (deleteResult == 200) {
            let _schema = await getProgressOperationalprogress(projectId, projectProgressId)
            console.log('getProgressOperationalprogress', _schema)
            onChangeIsEdit(false)
            setFormSchema(_schema)
          } else {
            setIsError(true)
          }
        }
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      editorData: data.editorData,
      planStatus: data.planStatus,
    }

    console.log('request body', request)
    handleCallService(request, progressId)
  }

  const onSubmitComment = (data) => {
    console.log('onSubmitComment', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      projectProgressId: progressId,
      masterSubjectId: formSchema.comment.masterSubjectId,
      value: {
        id: formSchema.comment.id,
        value: data.comment,
      },
    }

    console.log('request body', request)
    handleCallCommentService(request, progressId)
  }

  const OperationalProgressForm = (
    <Form>
      <FormGroup controlId="radioList">
        <Controller
          key={formSchema.planStatus.name}
          name={formSchema.planStatus.name}
          defaultValue={formSchema.planStatus.value}
          control={control}
          render={(props) => {
            return (
              <RadioGroup
                name={formSchema.planStatus.name}
                inline
                defaultValue={formSchema.planStatus.value}
                onChange={(value) => {
                  props.onChange(value)
                }}
              >
                {formSchema.planStatus.options?.map((item) => {
                  return <Radio value={item.value}>{item.label}</Radio>
                })}
              </RadioGroup>
            )
          }}
        />
      </FormGroup>
      <CKEditorFrom
        schema={formSchema.editorData}
        register={register}
        Controller={Controller}
        control={control}
        errors={errors}
        setValue={setValue}
        clearErrors={clearErrors}
        //maxLength={1000}
      />
    </Form>
  )

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {formSchema?.comment?.enableEdit ? (
        <>
          <div>
            <p>
              การดำเนินงาน:{' '}
              <b>
                {getValueFromOptions(formSchema.planStatus.options, formSchema.planStatus.value)}
              </b>
            </p>
            {formSchema.editorData.value ? (
              <div dangerouslySetInnerHTML={{ __html: formSchema.editorData.value }} />
            ) : (
              <div>-ไม่ระบุ-</div>
            )}
          </div>
          <hr />
          {isEdit ? (
            <CommentForm
              schema={formSchema.comment}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          ) : (
            <div>
              <CommentView schema={formSchema.comment} />
            </div>
          )}
        </>
      ) : (
        <>
          <WarningMessage style={{ marginBottom: 10 }} message={formSchema?.comment?.value} />

          {isEdit ? (
            OperationalProgressForm
          ) : (
            <div>
              <p>
                การดำเนินงาน:{' '}
                <b>
                  {getValueFromOptions(formSchema.planStatus.options, formSchema.planStatus.value)}
                </b>
              </p>
              {formSchema.editorData.value ? (
                <div dangerouslySetInnerHTML={{ __html: formSchema.editorData.value }} />
              ) : (
                <div>-ไม่ระบุ-</div>
              )}
            </div>
          )}
        </>
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={
              formSchema?.comment?.enableEdit
                ? formSchema?.comment?.buttonText
                : formSchema.buttonText
            }
            onSave={handleSubmit(formSchema.comment?.enableEdit ? onSubmitComment : onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}
